module.exports = __webpack_public_path__ + "img/trustpilot-logo.c28d3030.svg";